import RequesterLookup from "../RequesterLookup/RequesterLookup"
import { Wrapper, Title, Headline, Element } from "./NonPoRequesterTab.styles"

export default function NonPoRequesterTab() {
  return (
    <Wrapper>
      <Title>
        No requester found for this non-PO invoice
      </Title>
      <Headline>Please select the correct requester</Headline>
      <Element>
        <RequesterLookup />
      </Element>
    </Wrapper>
  )
}
